import { IconPlus } from '@tabler/icons-react';
import type React from 'react';
import { useState } from 'react';
import type { IntegrationProfileApiRow } from '@/api/integration-profiles';
import { useIntegrationProfiles } from '@/hooks/use-integration-profiles';
import { IntegrationProfilesTable } from './integration-profiles-table';
import { AddIntegrationProfileModal } from './modals/add-integration-profile-modal';
import { DeleteIntegrationProfileDialog } from './modals/delete-integration-profile-dialog';
import { EditIntegrationProfileModal } from './modals/edit-integration-profile-modal';
import { Button } from './ui/button';

interface IntegrationProfilesSectionProps {
  partyId: string;
}

export const IntegrationProfilesSection: React.FC<IntegrationProfilesSectionProps> = ({
  partyId,
}) => {
  const hook = useIntegrationProfiles(partyId);
  const [addOpen, setAddOpen] = useState(false);
  const [editProfile, setEditProfile] = useState<IntegrationProfileApiRow | null>(null);
  const [deleteProfile, setDeleteProfile] = useState<IntegrationProfileApiRow | null>(null);

  return (
    <div className="px-4 lg:px-6">
      <div className="rounded-md border">
        <div className="flex items-start justify-between p-5 border-b">
          <div>
            <p className="font-medium text-sm">Integration Profiles</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              How the platform talks to this provider — SFTP, API, or webhook.
            </p>
          </div>
          <Button variant="default" size="sm" className="gap-1.5" onClick={() => setAddOpen(true)}>
            <IconPlus size={14} />
            Add Integration Profile
          </Button>
        </div>

        <div className="p-4">
          <IntegrationProfilesTable
            profiles={hook.profiles}
            pagination={hook.pagination}
            isLoading={hook.isLoading}
            error={hook.error}
            onEdit={setEditProfile}
            onDelete={setDeleteProfile}
            onSortChange={hook.setSort}
            onPageChange={hook.setPage}
          />
        </div>
      </div>

      <AddIntegrationProfileModal
        partyId={partyId}
        open={addOpen}
        onOpenChange={setAddOpen}
        onSuccess={() => {
          setAddOpen(false);
          hook.refetch();
        }}
      />

      <EditIntegrationProfileModal
        profile={editProfile}
        onOpenChange={(open) => {
          if (!open) setEditProfile(null);
        }}
        onSuccess={() => {
          setEditProfile(null);
          hook.refetch();
        }}
      />

      <DeleteIntegrationProfileDialog
        profile={deleteProfile}
        onOpenChange={(open) => {
          if (!open) setDeleteProfile(null);
        }}
        onSuccess={() => {
          setDeleteProfile(null);
          hook.refetch();
        }}
      />
    </div>
  );
};
